import EnrollmentFileDetails from 'Enrollment/components/EnrollmentFileProcessing/EnrollmentFileDetails';
import EnrollmentFileProcessing from 'Enrollment/components/EnrollmentFileProcessing/EnrollmentFileProcessing';
import EnrollmentFileRejects from 'Enrollment/components/EnrollmentFileProcessing/EnrollmentFileRejects';
import EnrollmentDashboard from 'Enrollment/components/EnrollmentsDashboard/Dashboard';
import EnrollmentFilesNotProcessed from 'Enrollment/components/EnrollmentFilesNotProcessed/EnrollmentFilesNotProcessed';
import React, {useMemo} from 'react';
import {Route, Switch, RouteComponentProps, useParams} from 'react-router-dom';
import AWDStatusDetails from './components/EnrollmentFileProcessing/AWDStatusDetails';
import EnrollmentFileApplicationDetails from './components/EnrollmentFileProcessing/EnrollmentFileApplicationDetails';
import EnrollmentFileRejectDetails from './components/EnrollmentFileProcessing/EnrollmentFileRejectDetails';
import ESRBPStatusDetails from './components/EnrollmentFileProcessing/ESRBPStatusDetails';
import EnrollmentApplicationFileValidationResults from './components/UploadEnrollmentApplications/EnrollmentApplicationFileValidationResults';
import UploadEnrollmentApplications from './components/UploadEnrollmentApplications/UploadEnrollmentApplications';
import EnrollmentApplicationFileAuditDetail from './components/UploadEnrollmentApplications/EnrollmentApplicationFileAuditDetail';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import qs from 'query-string';
import {EnrollmentApplicationStatus} from 'Shared/constants/EnrollmentApplicationStatus';
import EmployerEnrollments from './components/Enrollments/EmployerEnrollments';
import EmployerEnrollmentsDetails from './components/Enrollments/EmployerEnrollmentsDetails';
import EmployerDiscrepantEnrollmentsDetails from './components/Enrollments/EmployerDiscrepantEnrollmentsDetails';
import EnrollmentApplicationProcessing from './components/UploadEnrollmentApplications/EnrollmentApplicationProcessing';
import ExternalUploadQueue from './components/UploadEnrollmentApplications/ExternalUploadQueue';
import ExternalEnrollmentFileUploadDetails from './components/UploadEnrollmentApplications/ExternalEnrollmentFileUploadDetails';
import GenelcoSpreadsheetFileUploadDetails from './components/UploadEnrollmentApplications/GenelcoSpreadsheetFileUploadDetails';
import {EnrollmentDiscrepantStatus} from 'Shared/constants/EnrollmentDiscrepantStatus';
import {FinalDispositionStatus} from 'Shared/constants/FinalDispositionStatus';
import BrokerSpreadsheetErrorReview from './components/UploadEnrollmentApplications/BrokerSpreadsheetErrorReview';
import ETSAdminDashboard from './components/EnrollmentsDashboard/ETSAdminDashboard';
import GenelcoSpreadsheetUnsuccessfulEmployeeRecords from './components/UploadEnrollmentApplications/GenelcoSpreadsheetUnsuccessfulEmployeeRecords';
import EnrollmentFileRejectsEmailHistory from './components/EnrollmentFileProcessing/EnrollmentFileRejectsEmailHistory';
import ClientOnboardingMaintenance from './components/ClientOnboardingProfiles/ClientOnboardingMaintenance';
import GenelcoBatchFileManagementPage from 'Enrollment/components/GenelcoBatchFileManagement/GenelcoBatchFileManagementPage';
import { useSelector } from 'react-redux';
import { ReducerState } from 'rootReducer';
import * as EnrollmentFileActions from 'Enrollment/ducks/enrollmentFileProcessing';
import ExternalUploadQueueDetails from './components/UploadEnrollmentApplications/ExternalUploadQueueDetails';

const ROOT_URI = '/enrollment';

export const EnrollmentRouteConstants = {
  ENROLLMENT_FILES: ROOT_URI,
  ENROLLMENT_FILE_PROCESSING: `${ROOT_URI}/enrollmentFileProcessing/`,
  ENROLLMENT_FILE_DETAILS: (enrollmentFileId: string) =>
    `${ROOT_URI}/enrollmentFileProcessing/fileDetails?enrollmentFileId=${enrollmentFileId}`,
  ENROLLMENT_FILE_APPLICATION_STATUS_DETAILS: (
    caseRequestId: string,
    finalDispositionStatus: FinalDispositionStatus,
    statusId?: EnrollmentApplicationStatus
  ) =>
    `${ROOT_URI}/enrollmentFileProcessing/applications?caseRequestId=${caseRequestId}&finalDispositionStatus=${finalDispositionStatus}${
      statusId ? `&statusId=${statusId}` : ''
    }`,
  ENROLLMENT_FILE_APPLICATION_BP_STATUS_DETAILS: (
    requestId: string,
    caseRequestId?: string,
    finalDispositionStatus?: FinalDispositionStatus,
    statusId?: EnrollmentApplicationStatus
  ) =>
    `${ROOT_URI}/enrollmentFileProcessing/applications/BPStatusDetails?caseRequestId=${caseRequestId}&id=${requestId}&finalDispositionStatus=${finalDispositionStatus}${
      statusId ? `&statusId=${statusId}` : ''
    }`,
  ENROLLMENT_FILE_APPLICATION_AWD_STATUS_DETAILS: (
    requestId: string,
    caseRequestId: string,
    awdSystemId: string,
    finalDispositionStatus: FinalDispositionStatus,
    statusId?: EnrollmentApplicationStatus
  ) =>
    `${ROOT_URI}/enrollmentFileProcessing/applications/AWDHistoryDetails?caseRequestId=${caseRequestId}&id=${requestId}&awdSystemId=${awdSystemId}&finalDispositionStatus=${finalDispositionStatus}${
      statusId ? `&statusId=${statusId}` : ''
    }`,
  ENROLLMENT_FILE_ERRORS: `${ROOT_URI}/enrollmentFileErrors`,
  ENROLLMENT_FILE_ERROR_DETAILS: (id: string, applicationSource: string) =>
    `${ROOT_URI}/enrollmentFileErrors/errorDetails/${id}/${applicationSource}`,
  ENROLLMENT_FILE_ERRORS_EMAIL_HISTORY: (id: string, applicationSource: string) =>
    `${ROOT_URI}/enrollmentFileErrors/errorDetails/${id}/${applicationSource}/email/history`,
  ENROLLMENTS_DASHBOARD: `${ROOT_URI}/enrollmentsDashboard`,
  ENROLLMENTS_ETS_ADMIN_DASHBOARD: `${ROOT_URI}/enrollmentsETSAdminDashboard`,

  EMPLOYER_ENROLLMENTS: `${ROOT_URI}/employerEnrollments`,
  EMPLOYER_ENROLLMENTS_DETAILS: (accountNumber?: string | null, discrepantStatus?: EnrollmentDiscrepantStatus) =>
    `${ROOT_URI}/employerEnrollments/details?accountNumber=${
      accountNumber ? accountNumber : ''
    }&discrepantStatus=${discrepantStatus}`,
  EMPLOYER_ENROLLMENTS_DISCREPANT_DETAILS: (discrepantStatus?: EnrollmentDiscrepantStatus) =>
   `${ROOT_URI}/employerEnrollments/discrepant/details?discrepantStatus=${discrepantStatus}`,
  ENROLLMENT_FILES_NOT_PROCESSED: `${ROOT_URI}/enrollmentFilesNotProcessed`,
  UPLOAD_ENROLLMENT_FILE_APPLICATIONS: `${ROOT_URI}/uploadEnrollmentApplications`,
  ENROLLMENT_APPLICATION_FILE_VALIDATION_RESULTS: (fileId: string) =>
    `${ROOT_URI}/uploadEnrollmentApplications/validationStatus/${fileId}`,
  ENROLLMENT_APPLICATION_FILE_AUDIT_DETAIL: (fileId: string) =>
    `${ROOT_URI}/uploadEnrollmentApplications/validationStatus/${fileId}/auditDetail`,
  ENROLLMENT_APPLICATION_PROCESSING: `${ROOT_URI}/enrollmentApplicationProcessing`,
  BROKER_SPREADSHEET_STATUS_DETAILS: (fileId: string) =>
    `${ROOT_URI}/uploadEnrollmentApplications/enrollmentSpreadsheetStatusDetails/${fileId}`,
  ENROLLMENT_GENELCOSHEET_STATUS_DETAILS: (fileId: string) =>
    `${ROOT_URI}/uploadEnrollmentApplications/enrollmentGenelcosheetStatusDetails/${fileId}`,
  BROKER_SPREADSHEET_STATUS_ERROR_REVIEW: (fileId: string) =>
    `${ROOT_URI}/uploadEnrollmentApplications/enrollmentSpreadsheetStatusDetails/${fileId}/errorReview`,
  EXTERNAL_UPLOAD_QUEUE: `${ROOT_URI}/brokerSpreadsheetUploads`,
  ENROLLMENT_GENELCOSHEET_STATUS_UNSUCCESSFUL_EMPLOYEE_RECORDS: (fileId: string) =>
    `${ROOT_URI}/uploadEnrollmentApplications/enrollmentGenelcosheetStatusDetails/${fileId}/unsuccessfulEmployees`,
  FILE_UPLOAD: `${ROOT_URI}/uploadEnrollmentApplications`,
  UPLOAD_ENROLLMENT_EMPLOYER_PROFILES: `${ROOT_URI}/clientOnboardingMaintenance`,
  GENELCO_BATCH_FILE_MANAGEMENT: `${ROOT_URI}/genelcoBatchFileManagement`,
  EXTERNAL_UPLOAD_QUEUE_DETAILS: (fileId: string) =>
  `${ROOT_URI}/brokerSpreadsheetUploads/Details/${fileId}`,
};

export default () => {
  return (
    <Route
      path={ROOT_URI}
      render={() => (
        <Switch>
          <Route
            path={EnrollmentRouteConstants.UPLOAD_ENROLLMENT_FILE_APPLICATIONS}
            render={routeProps => <RoutesUnderFileUpload {...routeProps} />}
          />
          <Route
            path={EnrollmentRouteConstants.ENROLLMENT_FILE_PROCESSING}
            render={() => <RoutesUnderEnrollmentFiles />}
          />
          <Route
            path={EnrollmentRouteConstants.ENROLLMENT_FILE_ERRORS}
            render={routeProps => <RoutesUnderEnrollmentFileErrors {...routeProps} />}
          />
          <Route
            exact
            path={EnrollmentRouteConstants.ENROLLMENT_FILES_NOT_PROCESSED}
            render={() => <RoutesUnderEnrollmentFilesNotProcessed />}
          />
          <Route
            path={EnrollmentRouteConstants.ENROLLMENTS_DASHBOARD}
            render={() => <RoutesUnderEnrollmentFileDashboard />}
          />
          <Route
            path={EnrollmentRouteConstants.ENROLLMENTS_ETS_ADMIN_DASHBOARD}
            render={() => <RoutesUnderEnrollmentFileETSAdminDashboard />}
          />
          <Route
            path={EnrollmentRouteConstants.EMPLOYER_ENROLLMENTS}
            render={routeProps => <RoutesUnderEmployerEnrollments {...routeProps} />}
          />
          <Route
            path={EnrollmentRouteConstants.ENROLLMENT_APPLICATION_PROCESSING}
            render={() => <RoutesUnderEnrollmentApplicationProcessing />}
          />
          <Route
            path={EnrollmentRouteConstants.EXTERNAL_UPLOAD_QUEUE}
            render={routeProps => <RoutesUnderExternalUploadQueue {...routeProps} />}
          />
          <Route path={EnrollmentRouteConstants.FILE_UPLOAD} render={() => <UploadEnrollmentApplications />} />
          <Route
            path={EnrollmentRouteConstants.UPLOAD_ENROLLMENT_EMPLOYER_PROFILES}
            render={() => <RoutesUnderClientOnboardingMaintenance />}
          />
          <Route
            path={EnrollmentRouteConstants.GENELCO_BATCH_FILE_MANAGEMENT}
            render={() => <RoutesUnderGenelcoBatchFile />}
          />
        </Switch>
      )}
    />
  );
};

const RoutesUnderEnrollmentFiles = () => {
  useBreadcrumbs('Enrollment Files', EnrollmentRouteConstants.ENROLLMENT_FILE_PROCESSING);
  return (
    <Route
      path={EnrollmentRouteConstants.ENROLLMENT_FILE_PROCESSING}
      render={routeProps => <RoutesUnderEnrollmentFileDetails {...routeProps} />}
    />
  );
};

const RoutesUnderEnrollmentFileDetails = (routeProps: RouteComponentProps) => {
  return (
    <Switch>
      <Route exact path={`${routeProps.match.url}/fileDetails`} render={() => <EnrollmentFileDetails />} />
      <Route
        path={`${routeProps.match.url}/applications`}
        render={routeProps => <RoutesUnderEnrollmentFileApplicationDetails {...routeProps} />}
      />
      <Route exact path={EnrollmentRouteConstants.ENROLLMENT_FILE_PROCESSING} component={EnrollmentFileProcessing} />
    </Switch>
  );
};

const RoutesUnderEnrollmentFileApplicationDetails = (routeProps: RouteComponentProps) => {
  const search = useMemo(() => routeProps.location.search, []);
  const {caseRequestId} = qs.parse(search) as {caseRequestId: string; id: string};
  const finalDispositionStatus = (qs.parse(search).finalDispositionStatus as unknown) as FinalDispositionStatus;
  const statusId = (qs.parse(search).statusId as unknown) as EnrollmentApplicationStatus;
  useBreadcrumbs(
    'Application Details',
    EnrollmentRouteConstants.ENROLLMENT_FILE_APPLICATION_STATUS_DETAILS(caseRequestId, finalDispositionStatus, statusId)
  );
  return (
    <Switch>
      <Route exact path={`${routeProps.match.url}/AWDHistoryDetails`} render={() => <AWDStatusDetails />} />
      <Route exact path={`${routeProps.match.url}/BPStatusDetails`} render={() => <ESRBPStatusDetails />} />
      <Route exact path={`${routeProps.match.url}`} render={() => <EnrollmentFileApplicationDetails />} />
    </Switch>
  );
};

const RoutesUnderEnrollmentFileErrors = (routeProps: RouteComponentProps) => {
  useBreadcrumbs('Enrollment File Errors', EnrollmentRouteConstants.ENROLLMENT_FILE_ERRORS);

  return (
    <Switch>
      <Route exact path={EnrollmentRouteConstants.ENROLLMENT_FILE_ERRORS} render={() => <EnrollmentFileRejects />} />
      <Route
        path={`${routeProps.match.url}/errorDetails/:id/:applicationSource`}
        render={() => <RoutesUnderEnrollmentFileErrorDetails />}
      />
    </Switch>
  );
};

const RoutesUnderEnrollmentFileErrorDetails = () => {
  const {id, applicationSource} = useParams();
  useBreadcrumbs('Enrollment File Error Details', EnrollmentRouteConstants.ENROLLMENT_FILE_ERROR_DETAILS(id!, applicationSource!));
  return (
    <Switch>
      <Route
        exact
        path={EnrollmentRouteConstants.ENROLLMENT_FILE_ERROR_DETAILS(':id', ':applicationSource')}
        render={() => <EnrollmentFileRejectDetails />}
      />
      <Route
        exact
        path={EnrollmentRouteConstants.ENROLLMENT_FILE_ERRORS_EMAIL_HISTORY(':id', ':applicationSource')}
        render={() => <RoutesUnderEnrollmentFileErrorDetailsEmailHistory />}
      />
    </Switch>
  );
};

const RoutesUnderEnrollmentFileErrorDetailsEmailHistory = () => {
  const {id, applicationSource} = useParams();
  useBreadcrumbs(
    'E-mail History',
    EnrollmentRouteConstants.ENROLLMENT_FILE_ERRORS_EMAIL_HISTORY(id!, applicationSource!)
  );
  return (
    <Switch>
      <Route
        exact
        path={EnrollmentRouteConstants.ENROLLMENT_FILE_ERRORS_EMAIL_HISTORY(':id', ':applicationSource')}
        render={() => <EnrollmentFileRejectsEmailHistory />}
      />
    </Switch>
  );
};

const RoutesUnderEnrollmentFileDashboard = () => {
  useBreadcrumbs('Dashboard', EnrollmentRouteConstants.ENROLLMENTS_DASHBOARD);
  return <Route exact path={EnrollmentRouteConstants.ENROLLMENTS_DASHBOARD} component={EnrollmentDashboard} />;
};
const RoutesUnderEnrollmentFileETSAdminDashboard = () => {
  useBreadcrumbs('ETS Admin Dashboard', EnrollmentRouteConstants.ENROLLMENTS_ETS_ADMIN_DASHBOARD);
  return <Route exact path={EnrollmentRouteConstants.ENROLLMENTS_ETS_ADMIN_DASHBOARD} component={ETSAdminDashboard} />;
};

const RoutesUnderEnrollmentFilesNotProcessed = () => {
  useBreadcrumbs('Files Not Processed', EnrollmentRouteConstants.ENROLLMENT_FILES_NOT_PROCESSED);
  return (
    <Route
      exact
      path={EnrollmentRouteConstants.ENROLLMENT_FILES_NOT_PROCESSED}
      render={() => <EnrollmentFilesNotProcessed />}
    />
  );
};

const RoutesUnderEmployerEnrollments = (routeProps: RouteComponentProps) => {
  useBreadcrumbs('Account Enrollments', EnrollmentRouteConstants.EMPLOYER_ENROLLMENTS);
  return (
    <Switch>
      <Route exact path={EnrollmentRouteConstants.EMPLOYER_ENROLLMENTS} render={() => <EmployerEnrollments />} />
      <Route exact path={`${routeProps.match.url}/details`} render={() => <EmployerEnrollmentsDetails />} />
      <Route exact path={`${routeProps.match.url}/discrepant/details`} render={() => <EmployerDiscrepantEnrollmentsDetails />} />
    </Switch>
  );
};

const RoutesUnderFileUpload = (routeProps: RouteComponentProps) => {

 const {enrollmentFilesFilter} = useSelector((state: ReducerState) => state.enrollmentFileProcessing);
 let enrollmentFilesFilterData = enrollmentFilesFilter as EnrollmentFileActions.ESREnrollmentFileFilters;

 useBreadcrumbs(
   enrollmentFilesFilterData.isEnrollmentFileDetails? 'Enrollment Files': 'File Upload',
   enrollmentFilesFilterData.isEnrollmentFileDetails
     ? EnrollmentRouteConstants.ENROLLMENT_FILE_PROCESSING
     : EnrollmentRouteConstants.UPLOAD_ENROLLMENT_FILE_APPLICATIONS);

   return (
    <Switch>
      <Route path={`${routeProps.match.url}/validationStatus/:fileId`} render={() => <RoutesUnderValidationStatus />} />
      <Route
        exact
        path={EnrollmentRouteConstants.UPLOAD_ENROLLMENT_FILE_APPLICATIONS}
        render={() => <UploadEnrollmentApplications />}
      />
      <Route
        exact
        path={EnrollmentRouteConstants.ENROLLMENT_APPLICATION_PROCESSING}
        render={() => <EnrollmentApplicationProcessing />}
      />
      <Route
        path={`${routeProps.match.url}/enrollmentSpreadsheetStatusDetails/:fileId`}
        render={() => <RoutesUnderExternalEnrollmentFileUploadDetails />}
      />
      <Route
        path={`${routeProps.match.url}/enrollmentGenelcosheetStatusDetails/:fileId`}
        render={() => <RoutesUnderGenelcoSpreadsheetFileUploadDetails />}
      />
    </Switch>
  );
};

const RoutesUnderClientOnboardingMaintenance = () => {
  useBreadcrumbs('Bulk Profile Setup', EnrollmentRouteConstants.UPLOAD_ENROLLMENT_EMPLOYER_PROFILES);
  return (
    <Switch>
      <Route
        exact
        path={EnrollmentRouteConstants.UPLOAD_ENROLLMENT_EMPLOYER_PROFILES}
        render={() => <ClientOnboardingMaintenance />}
      />
    </Switch>
  );
};

const RoutesUnderValidationStatus = () => {
  return (
    <Switch>
      <Route
        exact
        path={EnrollmentRouteConstants.ENROLLMENT_APPLICATION_FILE_AUDIT_DETAIL(':fileId')}
        render={() => <EnrollmentApplicationFileAuditDetail />}
      />
      <Route
        exact
        path={EnrollmentRouteConstants.ENROLLMENT_APPLICATION_FILE_VALIDATION_RESULTS(':fileId')}
        render={() => <EnrollmentApplicationFileValidationResults />}
      />
    </Switch>
  );
};
const RoutesUnderEnrollmentApplicationProcessing = () => {
  useBreadcrumbs('Enrollment Application Processing', EnrollmentRouteConstants.ENROLLMENT_FILES_NOT_PROCESSED);
  return (
    <Route
      exact
      path={EnrollmentRouteConstants.ENROLLMENT_APPLICATION_PROCESSING}
      render={() => <EnrollmentApplicationProcessing />}
    />
  );
};
const RoutesUnderExternalEnrollmentFileUploadDetails = () => {
  const {fileId} = useParams();
  useBreadcrumbs(
    'Broker Spreadsheet',
    EnrollmentRouteConstants.BROKER_SPREADSHEET_STATUS_DETAILS(fileId!)
  );
  return (
    <Switch>
      <Route
        path={EnrollmentRouteConstants.BROKER_SPREADSHEET_STATUS_ERROR_REVIEW(':fileId')}
        render={() => <BrokerSpreadsheetErrorReview />}
      />
      <Route
        exact
        path={EnrollmentRouteConstants.BROKER_SPREADSHEET_STATUS_DETAILS(':fileId')}
        render={() => <ExternalEnrollmentFileUploadDetails />}
      />
    </Switch>
  );
};
const RoutesUnderGenelcoSpreadsheetFileUploadDetails = () => {
  const {fileId} = useParams();
  useBreadcrumbs(
    'Genelco Spreadsheet',
    EnrollmentRouteConstants.ENROLLMENT_GENELCOSHEET_STATUS_DETAILS(fileId!)
  );
  return (
    <Switch>
      <Route
        path={EnrollmentRouteConstants.ENROLLMENT_GENELCOSHEET_STATUS_UNSUCCESSFUL_EMPLOYEE_RECORDS(':fileId')}
        render={() => <GenelcoSpreadsheetUnsuccessfulEmployeeRecords />}
      />
      <Route
        exact
        path={EnrollmentRouteConstants.ENROLLMENT_GENELCOSHEET_STATUS_DETAILS(':fileId')}
        render={() => <GenelcoSpreadsheetFileUploadDetails />}
      />
    </Switch>
  );
};
const RoutesUnderExternalUploadQueue = (routeProps: RouteComponentProps) => {

  useBreadcrumbs('Broker Spreadsheet Uploads', EnrollmentRouteConstants.EXTERNAL_UPLOAD_QUEUE);
 
    return (
     <Switch>
       <Route path={`${routeProps.match.url}/details/:fileName`} render={() => <RoutesUnderBrokerUploadDetails />} />
       <Route
         exact
         path={EnrollmentRouteConstants.EXTERNAL_UPLOAD_QUEUE}
         render={() => <ExternalUploadQueue />}
       />
     </Switch>
   );
 };

 const RoutesUnderBrokerUploadDetails = () => {
  const {fileId} = useParams();
  useBreadcrumbs(
    'View History',
    EnrollmentRouteConstants.EXTERNAL_UPLOAD_QUEUE_DETAILS(fileId!)
  );
  return (
      <Route
        path={EnrollmentRouteConstants.EXTERNAL_UPLOAD_QUEUE_DETAILS(':fileId')}
        render={() => <ExternalUploadQueueDetails />}
      />
  );
};
 
const RoutesUnderGenelcoBatchFile = () => {
  useBreadcrumbs('Genelco Batch File Management', EnrollmentRouteConstants.GENELCO_BATCH_FILE_MANAGEMENT);
  return (
    <Route
      exact
      path={EnrollmentRouteConstants.GENELCO_BATCH_FILE_MANAGEMENT}
      render={() => <GenelcoBatchFileManagementPage />}
    />
  );
};